/**
 * @typedef {Object} ReactReduxModalReducers
 * @property {ReactReduxModalState} initialState
 * @property {Function} reducer
 */

/**
 * @typedef {Object} ReactReduxModalState
 * @property {Boolean} isShowingModal
 */

/**
 * @param {ReactReduxModalActions} actions
 * @param {ReactReduxModalOptions} options
 * @return {ReactReduxModalReducers}
 */
export function buildReducer(actions, options) {

  /** @type {ReactReduxModalState} */
  const initialState = Object.assign({
    isShowingModal: false,
  }, options.initialState || {});

  /**
   * @param {ReactReduxModalState} state
   * @param {ReduxAction<any>} action
   * @return {ReactReduxModalState}
   */
  function reducer(state = initialState, action) {
    switch (action.type) {
      case actions.showModal.TYPE:
        return {
          ...state,
          ...action.payload,
          isShowingModal: true,
        };
      case actions.hideModal.TYPE:
        return initialState;
      default:
        return state;
    }
  }

  return {
    initialState,
    reducer,
  };
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/react-redux-modals/reducers.js